import {request} from '@/helpers/apiClient'
import {DOWNLOAD_TEMPLATE_CONFIG} from '@/utils/constants/apiConfig/downloadTemplateConfig'

export const TEMPLATE_TYPE = Object.freeze({
  TIER_CUSTOMERS: 'Tier Customers',
  PRODUCT_TEMPLATE: 'Product Template',
  BULK_POINT_MODIFIER: 'Bulk Point Modifier',
  POINT_MULTIPLIER: 'Point Multiplier',
})

export const downloadTemplateFile = async body => {
  return request(DOWNLOAD_TEMPLATE_CONFIG.DOWNLOAD_TEMPLATE, {data: body})
}
